/** Shared helpers for min-purchase offer quantity and messaging. */

export const formatCurrencyAmount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) {
    return '0';
  }
  const rounded = Math.round(amount * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
};

export const parseOfferMaxQty = (value) => {
  if (value == null || value === '') {
    return null;
  }
  const qty = Number(value);
  if (!Number.isFinite(qty)) {
    return null;
  }
  return Math.max(0, Math.floor(qty));
};

export const getOfferLineQuantity = (productId, offerId, cartItems) =>
  (cartItems?.items ?? []).reduce((total, item) => {
    const isMatchingOfferLine =
      item?.isOfferItem &&
      String(item?.productId ?? item?.itemId) === String(productId) &&
      (offerId == null || String(item?.offerId ?? '') === String(offerId));
    if (!isMatchingOfferLine) {
      return total;
    }
    return total + Number(item?.quantity ?? 0);
  }, 0);

/**
 * Current offer products are unlocked when cart itemsTotal meets minPurchaseAmount.
 * `amountNeeded` is for the *next* tier messaging and must not disable Add.
 */
export const isOfferEligible = (offerInfo, itemsTotal) => {
  const offer = offerInfo?.offer;
  if (!offer?.isActive) {
    return false;
  }

  const minPurchase = Number(offer?.minPurchaseAmount);
  if (Number.isFinite(minPurchase) && itemsTotal != null && itemsTotal !== '') {
    return Number(itemsTotal) >= minPurchase;
  }

  return Number(offerInfo?.amountNeeded ?? 0) <= 0;
};

/**
 * Map offer specialPriceProducts into the GroceryItemCard item shape.
 * Shows specialPrice only (mrp matched so no strikethrough).
 */
export const mapSpecialPriceProductToCardItem = (
  product,
  offer,
  { customerType, generalCustomerType } = {},
) => {
  const specialPrice = Number(product?.specialPrice);
  const priceValue = Number.isFinite(specialPrice) ? specialPrice : 0;
  const priceCustomerTypes = [
    ...new Set(
      [customerType, generalCustomerType].filter(
        (type) => type !== undefined && type !== null && type !== false && type !== '',
      ),
    ),
  ];
  const prices =
    priceCustomerTypes.length > 0
      ? priceCustomerTypes.map((type) => ({
          customerType: type,
          sellingPrice: priceValue,
        }))
      : [{ customerType: 0, sellingPrice: priceValue }];

  return {
    itemId: product?.productId,
    productId: product?.productId,
    skuId: product?.skuId,
    name: product?.productName,
    image: product?.image,
    mrp: priceValue,
    prices,
    measure: product?.measure,
    unit: product?.unit,
    isOfferItem: true,
    offerId: offer?._id,
    offerName: offer?.name,
    specialPrice: priceValue,
    maxOfferQty: product?.maxQty ?? product?.maxOfferQty,
  };
};
